export { DeleteAuthUserDialogComponent } from './delete-auth-user-dialog/delete-auth-user-dialog.component';
